<template>
    <div>
        <el-card>
            <div class="tableBox">
                <div>
                    <div>
                        <span>细化发布</span>
                        <span>发布RFC关闭数量组别统计</span>
                    </div>
                    <img src="../../../../assets/icon_logo.png">
                </div>
                <div>
                    <div>
                        <div style="position:relative;height:20px;">
                            <div class="helpDiv" style="position: absolute;top:-20px">
                                <b class="helpI"></b>
                                <a href="https://wiki.autoai.com/pages/viewpage.action?pageId=26157346"
                                target="_blank"
                                class="helpA">
                                    帮助指引
                                </a>
                            </div>
                        </div>
                        <el-form :inline="true" class="search-form">
                            <el-form-item label="">
                                <el-date-picker
                                    ref="dataPicker"
                                    @change="changeData"
                                    v-model="value"
                                    type="daterange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    value-format="yyyy-MM-dd">
                                </el-date-picker>
                            </el-form-item>
                            <el-button type="primary" @click="selectData">修改时间</el-button>
                            <el-button type="primary" @click="getExcel">导出excel</el-button>
                        </el-form>
                    </div>
                    <div class="tableClass">
                        <div>
                            <el-table id="table-content"
                                :data="tableData">
                                <el-table-column prop="groupName" label="组名"></el-table-column>
                                <el-table-column prop="complete_sucess" label="完全成功"></el-table-column>
                                <el-table-column prop="partial_success" label="部分成功"></el-table-column>
                                <el-table-column prop="cancel" label="取消"></el-table-column>
                                <el-table-column prop="reject" label="拒绝"></el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>
                <div>
                    <div>
                        <span>生成时间:</span>
                        <span>{{getMes.generateTime}}</span>
                    </div>
                    <span>itsmops.autoai.com</span>
                </div>
            </div>
        </el-card>
    </div>
</template>

<script>

    import services from '../reportRefining.service';
    import { export_json_to_excel } from '../../../../core/utils/Export2Excel';
    export default {
        data: function () {
            return {
                tableData: [],
                sortList:['descending', 'ascending'],
                value:'',
                getMes:{},
            }
        },
        mounted(){
            this.value = services.getDefaultData();
            this.getData();
        },
        methods:{
            getExcel(){
                services.exportToExcel(`发布RFC关闭数量组别统计${this.value[0]}—${this.value[1]}`);
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },
            getData(){//获取数据
                let params = {
                    startTime: this.value[0],
                    stopTime: this.value[1],
                }
                services.deployGroupCompletionCancelList(params).then(res=>{
                    this.getMes = res;
                    this.tableData = res.tableData;
                })
            },
            selectData(){//点击修改日期 日期控件自动聚焦
                let selData = this.$refs.dataPicker;
                selData.focus();
            },
            changeData(){//选择日期
                this.getData();
            },
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>

</style>
